import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { IUserListPayload } from '../../../schemas/manage/manage.Schema';
import {
  getMembersList,
  setSelectedUser,
  setFilter,
  resetLoadedStatus
} from '../../../actions/manage/action';
import { getUserMasterData, getNetworkStatus, getLoading } from '../../../selectors/selector';
import { UserDetails } from '../../../models/userProfile/userProfile.modal';
import {
  getManageUsers,
  getSelectedFilter,
  getManageUsersLoaded
} from '../../../selectors/Manage/selector';
import { searchByReferenceId, showNetworkAlert } from '../../../actions/App/action';
import useInjectSaga from '../../../utils/injectSaga';
import useInjectReducer from '../../../utils/injectReducer';
import reducer from '../../../reducers/manage/reducer';
import saga from '../../../saga/Manage/saga';
import { logEvent, setScreenName } from '../../../utils/Analytics';
import { EVENT, SCREEN } from '../../../utils/constants.analytics';
import { ManageUserPage } from '../../pages/ManageUser/index';
import { GET_MEMBERS_CONFIG } from '../../../utils/constants';
import { IONICWrapper } from '../../../utils/common';
import { getMyDriverShipments } from 'app/selectors/carrierAssign/selector';
import { getDriverCountForManageUsers, getMyLoadsFilteredCount } from 'app/selectors/Myload/selector';
import { fetchShipments, fetchShipmentsForDriverInManageUser } from 'app/actions/carrierAssign/action';

const key = 'manage';

export const ManageUserContainer: React.FC<any> = (props: any) => {
  const { userDetails, getUsersListFn, usersList, isUsersListLoaded, history } = props;

  const users = usersList.map((user: any) => {
    const roles = user.userApplicationDetails.reduce((roles: Array<any>, item: any) => {
      const itemRoles = (item.roles && item.roles.map((role: any) => role.roleName)) || [];
      return [...roles, ...itemRoles];
    }, []);
    return { ...user, roles };
  });

  const getUsersList = (isPullToRefresh = false) => {
    const userDetailsModel = new UserDetails();
    const page : string = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.page || GET_MEMBERS_CONFIG.page;
    const size : string = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.size || GET_MEMBERS_CONFIG.size;
    const sort : string = IONICWrapper?.details?.keys?.configuration?.getMembersConfig?.sort || GET_MEMBERS_CONFIG.sort;
    const fetchAllUsersQuery = userDetailsModel.getUsersForWeb(props.userDetails && props.userDetails.memberDetailsResponse &&
      props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId, '',size,page,sort);
    getUsersListFn({
      fetchAllUsersQuery,
      isPullToRefresh
    });
  };

  useEffect(() => {
    const status =
      (history?.location?.state?.resetLoaded) ||
      false;
    if (status) {
      props.resetUsersLoaded();
    }
  }, [history]);

  useEffect(() => {
      if(userDetails){
        getUsersList();
      }
      window.scrollTo(0,0);
  }, [userDetails]);

  // Analytics implementation
  setScreenName(SCREEN.MANAGE_USERS);
  logEvent(EVENT.SV_MANAGE_USERS, {
    screen: SCREEN.MANAGE_USERS,
    carrierId: props.userDetails && props.userDetails.memberDetailsResponse &&
    props.userDetails.memberDetailsResponse.member &&  props.userDetails.memberDetailsResponse.member.carrierId
  });
  return <ManageUserPage {...props} module="manage" users={users} getUsersList={getUsersList} />
};

const mapStateToProps = createStructuredSelector({
  userDetails: getUserMasterData(),
  usersList: getManageUsers(),
  isNetworkAvailable: getNetworkStatus(),
  filters: getSelectedFilter(),
  isUsersListLoaded: getManageUsersLoaded(),
  loads: getMyDriverShipments(),
  loading: getLoading(),
  getMyLoadsFilteredCount: getMyLoadsFilteredCount(),
  count: getDriverCountForManageUsers()

});

export const mapDispatchToProps = (dispatch: Function) => ({
  getUsersListFn: (payload: IUserListPayload) => dispatch(getMembersList(payload)),
  selectedUser: (payload: IUserListPayload) => dispatch(setSelectedUser(payload)),
  showNetworkAlert: () => dispatch(showNetworkAlert()),
  setFilter: (payload: any) => dispatch(setFilter(payload)),
  resetUsersLoaded: () => dispatch(resetLoadedStatus()),
  fetchMyloads: (details: any) => dispatch(fetchShipments(details, false)),
  fetchShipmentsManageUser: (details: any,isHideLoader = false,callBack:any) => dispatch(fetchShipments(details, false, callBack)),
  fetchShipmentsForDriverInManageUser: (details: any,isHideLoader = false,callBack:any) => dispatch(fetchShipmentsForDriverInManageUser(details, false, callBack)),
  searchByReferenceId: (payload: any, isHideLoader: boolean, callback?: any) => {
    dispatch(searchByReferenceId(payload, isHideLoader,callback))
  },
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withReducer = useInjectReducer({ key, reducer });
const withSaga = useInjectSaga({ key, saga });

export default compose(withSaga, withReducer, withConnect)(withRouter(ManageUserContainer));